import React from 'react';
import { Table, Input, InputNumber, Popconfirm, Form, Modal, Button, Select } from 'antd';
import { withTranslation } from 'react-i18next';
import { ModalBody, Container, TemplatesList, LoaderContainer, UpdateNote } from './styles';
import {
  getTagsList,
  addTagMapping,
  updateTagMapping,
  deleteTagMapping,
} from '../../utils/services/mailRoomAPI';
import Loader from '../Loader';
import { v4 as uuidv4 } from 'uuid';
import { TAG_MAPPING_MODAL as trans } from '../../containers/UserSettingsPage/TranslationValues';
import i18n from 'i18next';

const EditableContext = React.createContext();
const { Option } = Select;
const NAMESPACE = ['TAG_MAPPING_MODAL'];

class EditableCell extends React.Component {
  getInput = () => {
    if (this.props.inputType === 'number') {
      return <InputNumber />;
    }
    return <Input />;
  };

  renderCell = ({ getFieldDecorator }) => {
    const {
      editing,
      dataIndex,
      title,
      inputType,
      record,
      index,
      children,
      ...restProps
    } = this.props;
    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item style={{ margin: 0 }}>
            {getFieldDecorator(dataIndex, {
              rules: [
                {
                  required: true,
                  message: `${i18n.t(trans.EMPTY_TAG_NAME_COLUMN_WARNING_MESSAGE.key,trans.EMPTY_TAG_NAME_COLUMN_WARNING_MESSAGE.value)} ${title}!`,
                },
              ],
              initialValue: record[dataIndex],
            })(this.getInput())}
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };

  render() {
    return <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>;
  }
}
class EditableTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = { editingKey: '', loading: true, isAddNewData: false };
  }

  getColumns() {
    let columns = [
      {
        title: `${this.props.t(trans.TAG_ID_COLUMN_LABEL.key, trans.TAG_ID_COLUMN_LABEL.value)}`,
        dataIndex: 'tagId',
        width: '25%',
        render: (text, record) => {
          const { isAddNewData, missingTags } = this.state;
          const editable = this.isEditing(record);
          return editable && isAddNewData ? (
            <Select
              showSearch
              style={{ width: 200 }}
              placeholder={this.props.t(
                trans.SELECT_TAG_ID_PLACEHOLDER.key,
                trans.SELECT_TAG_ID_PLACEHOLDER.value,
              )}
              defaultValue={missingTags && missingTags.length > 0 && missingTags[0].tagId}
              optionFilterProp="children"
              onChange={e => this.setState({ selectedTagId: e })}
              filterOption={(input, option) =>
                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {missingTags.map(eachTag => (
                <Option value={eachTag.tagId}>{eachTag.tagId}</Option>
              ))}
            </Select>
          ) : (
            record.tagId
          );
        },
      },
      {
        title: `${this.props.t(
          trans.TAG_NAME_COLUMN_LABEL.key,
          trans.TAG_NAME_COLUMN_LABEL.value,
        )}`,
        dataIndex: 'tagName',
        width: '30%',
        editable: true,
      },
      {
        title: `${this.props.t(
          trans.CREATED_ON_COLUMN_LABEL.key,
          trans.CREATED_ON_COLUMN_LABEL.value,
        )}`,
        dataIndex: 'createdOn',
        width: '25%',
        editable: false,
      },
      {
        title: `${this.props.t(trans.ACTION_COLUMN_LABEL.key, trans.ACTION_COLUMN_LABEL.value)}`,
        dataIndex: 'operation',
        render: (text, record) => {
          const { editingKey } = this.state;
          const editable = this.isEditing(record);
          return editable ? (
            <span>
              <EditableContext.Consumer>
                {form =>
                  this.state.isAddNewData ? (
                    <a onClick={() => this.save(form, record.id)} style={{ marginRight: 8 }}>
                      {this.props.t(trans.ADD_NEW_TAG_ACTION.key, trans.ADD_NEW_TAG_ACTION.value)}
                    </a>
                  ) : (
                    <Popconfirm
                      title={
                        <>
                          {this.props.t(
                            trans.EDIT_TAG_CONFIRMATION_POPUP_TITLE.key,
                            trans.EDIT_TAG_CONFIRMATION_POPUP_TITLE.value,
                          )}
                          <UpdateNote>
                            {this.props.t(
                              trans.EDIT_TAG_CONFIRMATION_POPUP_NOTE_DESCRIPTION.key,
                              trans.EDIT_TAG_CONFIRMATION_POPUP_NOTE_DESCRIPTION.value,
                            )}
                          </UpdateNote>
                        </>
                      }
                      okText={this.props.t(
                        trans.CONFIRM_UPDATE_ACTION.key,
                        trans.CONFIRM_UPDATE_ACTION.value,
                      )}
                      cancelText={this.props.t(
                        trans.DECLINE_UPDATE_ACTION.key,
                        trans.DECLINE_UPDATE_ACTION.value,
                      )}
                      onConfirm={() => this.save(form, record.id)}
                    >
                      <a style={{ marginRight: 8 }}>
                        {this.props.t(
                          trans.SHOW_COFIRMATION_POPUP_TO_UPDATE_TAG_ACTION.key,
                          trans.SHOW_COFIRMATION_POPUP_TO_UPDATE_TAG_ACTION.value,
                        )}
                      </a>
                    </Popconfirm>
                  )
                }
              </EditableContext.Consumer>
              {!this.state.isAddNewData && (
                <Popconfirm
                  title={this.props.t(
                    trans.CANCEL_TAG_CHANGES_POPUP_TITLE.key,
                    trans.CANCEL_TAG_CHANGES_POPUP_TITLE.value,
                  )}
                  okText={this.props.t(
                    trans.CONFIRM_CANCEL_ACTION.key,
                    trans.CONFIRM_CANCEL_ACTION.value,
                  )}
                  cancelText={this.props.t(
                    trans.DECLINE_CANCEL_ACTION.key,
                    trans.DECLINE_CANCEL_ACTION.value,
                  )}
                  onConfirm={() => this.cancel(record.id)}
                >
                  <a style={{ marginRight: 8 }}>
                    {this.props.t(
                      trans.CANCEL_CURRENT_CHANGES_MADE_TO_TAG_ACTION.key,
                      trans.CANCEL_CURRENT_CHANGES_MADE_TO_TAG_ACTION.value,
                    )}
                  </a>
                </Popconfirm>
              )}
              <Popconfirm
                title={this.props.t(trans.DELETE_TAG_TITLE.key, trans.DELETE_TAG_TITLE.value)}
                okText={this.props.t(
                  trans.CONFIRM_DELETE_ACTION.key,
                  trans.CONFIRM_DELETE_ACTION.value,
                )}
                cancelText={this.props.t(
                  trans.DECLINE_DELETE_ACTION.key,
                  trans.DECLINE_DELETE_ACTION.value,
                )}
                onConfirm={() =>
                  this.state.isAddNewData
                    ? this.handleDeleteNewTag(record.id)
                    : this.handleDeleteTag(record.id)
                }
              >
                <a>{this.props.t(trans.DELETE_TAG_ACTION.key, trans.DELETE_TAG_ACTION.value)}</a>
              </Popconfirm>
            </span>
          ) : (
            <a disabled={editingKey !== ''} onClick={() => this.edit(record.id)}>
              {this.props.t(trans.EDIT_TAG_ROW.key, trans.EDIT_TAG_ROW.value)}
            </a>
          );
        },
      },
    ];
    if (!this.props.isEditable) {
      columns = columns?.filter(col => col.dataIndex !== 'operation');
    }
    return columns;
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    let tagsData = await getTagsList();
    if (tagsData && tagsData.data) {
      this.getMissedTags(tagsData.data);
      this.setState({
        data: tagsData.data,
        loading: false,
        editingKey: '',
        isAddNewData: false,
      });
    }
  };

  getMissedTags = tagData => {
    const myTagList = [
      { id: 1, tagId: 'tag1' },
      { id: 2, tagId: 'tag2' },
      { id: 3, tagId: 'tag3' },
      { id: 4, tagId: 'tag4' },
    ];
    let missingTags = myTagList.filter(object1 => {
      return !tagData.some(object2 => {
        return object1.tagId === object2.tagId;
      });
    });
    if (missingTags && missingTags.length > 0 && missingTags[0]?.tagId) {
      this.setState({ selectedTagId: missingTags[0]?.tagId });
    }
    this.setState({
      missingTags,
    });
  };

  isEditing = record => record.id === this.state.editingKey;

  cancel = () => {
    this.setState({ editingKey: '' });
  };

  save = (form, key) => {
    form.validateFields(async (error, row) => {
      if (error) {
        return;
      }
      const newData = [...this.state.data];
      const index = newData.findIndex(item => key === item.id);
      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, {
          ...item,
          ...row,
        });
        let payload;
        let updateTag;
        if (this.state.isAddNewData) {
          payload = {
            tagName: row.tagName,
            tagId: this.state.selectedTagId,
          };
          updateTag = await addTagMapping(payload);
        } else {
          payload = {
            id: key,
            tagName: row.tagName,
            tagId: item.tagId,
          };
          updateTag = await updateTagMapping(payload);
        }
        if (updateTag && updateTag.errors && updateTag.errors.length === 0) {
          if (this.state.isAddNewData) {
            this.fetchData();
          } else {
            this.setState({ data: newData, editingKey: '' });
          }
        }
      } else {
        newData.push(row);
        this.setState({ data: newData, editingKey: '' });
      }
    });
  };

  edit(key) {
    this.setState({ editingKey: key });
  }

  handleAdd = () => {
    const newData = {
      id: uuidv4(),
      tagName: 'Tag Name',
    };
    this.setState({
      data: [newData, ...this.state.data],
      editingKey: newData.id,
      isAddNewData: true,
    });
  };

  handleDeleteNewTag = key => {
    const dataSource = [...this.state.data];
    this.setState({
      data: dataSource.filter(item => item.id !== key),
      editingKey: '',
      isAddNewData: false,
    });
  };

  handleDeleteTag = async id => {
    let dataSource = [...this.state.data];
    let payload = { id: id };
    let deleteTag = await deleteTagMapping(payload);
    if (deleteTag && deleteTag.errors && deleteTag.errors.length === 0) {
      dataSource = dataSource.filter(item => item.id !== id);
      this.getMissedTags(dataSource);
      this.setState({
        data: dataSource,
        editingKey: '',
      });
    }
  };

  render() {
    const { onCancel, t } = this.props;
    const { loading, data, missingTags } = this.state;
    const components = {
      body: {
        cell: EditableCell,
      },
    };

    const columns = this.getColumns().map(col => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        onCell: record => ({
          record,
          inputType: col.dataIndex === 'age' ? 'number' : 'text',
          dataIndex: col.dataIndex,
          title: col.title,
          editing: this.isEditing(record),
        }),
      };
    });

    return (
      <Container onKeyDown={e => e.stopPropagation()}>
        <Modal
          title={
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              {t(trans.TAG_MAPPING_MODAL_TITLE.key, trans.TAG_MAPPING_MODAL_TITLE.value)}
            </div>
          }
          visible={true}
          maskClosable={false}
          width={1000}
          centered
          onCancel={onCancel}
          footer={false}
        >
          <ModalBody>
            {loading ? (
              <LoaderContainer isPrinterTag={1}>
                <Loader />
              </LoaderContainer>
            ) : (
              <EditableContext.Provider value={this.props.form}>
                <TemplatesList isPrinterTag={1}>
                  <Table
                    components={components}
                    bordered
                    dataSource={data}
                    columns={columns}
                    rowClassName="editable-row"
                    pagination={false}
                  />
                  {/* can have maximum of 4 tags */}
                  {missingTags.length > 0 &&
                    this.props.isEditable &&
                    data.length < 4 &&
                    this.state.editingKey === '' &&
                    !this.state.isAddNewData && (
                      <Button onClick={this.handleAdd} type="primary">
                        {t(trans.ADD_NEW_TAG_BUTTON.key, trans.ADD_NEW_TAG_BUTTON.value)}
                      </Button>
                    )}
                </TemplatesList>
              </EditableContext.Provider>
            )}
          </ModalBody>
        </Modal>
      </Container>
    );
  }
}

const TagConfigModal = Form.create()(EditableTable);
export default withTranslation(NAMESPACE)(TagConfigModal);
